import { DenormalizedCustomizableGroup, DenormalizedCustomizableQuestion } from '@packages/types'
import React, { useContext } from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import BurgerIcon from 'icons/bold/01-Interface Essential/03-Menu/navigation-menu.svg'
import ChevronIcon from 'icons/bold/52-Arrows-Diagrams/01-Arrows/arrow-up-1.svg'

import SummaryDrawerContext from './context/SummaryDrawerContext'

import './SummaryDrawerButton.scss'

export type SummaryDrawerButtonProps = {
  steps: (DenormalizedCustomizableGroup | DenormalizedCustomizableQuestion)[]
  selectedStepId: string
}

const SummaryDrawerButton = ({ steps, selectedStepId }: SummaryDrawerButtonProps) => {
  const { drawer } = useContext(SummaryDrawerContext)

  const questionPanelStyle = useThemeSettings('questionPanel')

  const stepIndex = steps.findIndex(step => step.id === selectedStepId)
  const numberOfSteps = steps.length

  const Icon = questionPanelStyle.mobileNavSummaryButtonIcon === 'chevron' ? ChevronIcon : BurgerIcon

  return (
    <button
      className="summary-drawer__button"
      style={{ color: questionPanelStyle.mobileNavSummaryButtonColor }}
      onClick={() => drawer.snap(1)}
    >
      <Icon
        className="summary-drawer__button-icon"
        aria-label="summary drawer"
        style={{ fill: questionPanelStyle.mobileNavSummaryButtonColor }}
      />
      {stepIndex + 1}/{numberOfSteps}
    </button>
  )
}

export default SummaryDrawerButton
